import React, {useState, useEffect, useRef /*, useContext */ } from 'react';
import { Form, Input, message, InputNumber, DatePicker, Card, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { useNavigate } from 'react-router-dom';

function AddStageAdvanced(props) {
    // console.warn('props di AddStage:', props);
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const [season, setSeason] = useState({});
    let navigate = useNavigate();
    
    useEffect(() => {
        if (props.season.value && props.season.value.payLoad) {
            setSeason(props.season.value.payLoad);
        }
    }, [props.season])

    async function onFinish(values) {
        // values.stageId = props.seasonId
        // console.warn('values della form: ', values)
        const bodyValues = {};
        const stringDate = values.date.format('YYYY-MM-DDTHH:mm:ssZ');
        if (values.round === undefined || values.round === null || values.round === '' || values.round === 0) {
            values.round = 1;
        }
        bodyValues.date = stringDate;
        bodyValues.name = values.name;
        bodyValues.stageNumber = values.stageNumber;
        bodyValues.round = 1;
        // TODO: se round è 0 o undefined, mettiamo round a 1, altrimenti si blocca tutto. 
        // In futuro, se vogliamo permettere di inserire round diversi da 1, dobbiamo gestire meglio questo aspetto.
        // bodyValues.round = values.round;
        bodyValues.turns = values.turns;
        bodyValues.playerCap = values.playerCap;
        
        const response = await fetch(api.stages().create(props.id).href, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(bodyValues) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())
        .then(() => {
            messageApi.open({
                type: 'success',
                content: 'Tappa inserita correttamente!',
            })
            
            //window.location.reload(false);
            navigate(`/seasons/${props.id}`);
        })
    }

    function toggleCancel() {
        navigate(`/seasons/${props.id}`);
    }

    // const season = (props.season.value && props.season.value.payLoad ? props.season.value.payLoad : {});
    const league = (season && season.hostingLeague ? season.hostingLeague : {});
    
    return(
            <>
                {contextHolder}
                <Card title="Aggiungi Tappa">
                    <Form form={form} onFinish={onFinish} layout="horizontal" labelCol={{ span: 4}} wrapperCol={{ span: 8 }} style={{ maxWidth: '70%' , textAlign: 'left' }} >
                        <Form.Item label="League" name="league">
                            {league.leagueName}
                        </Form.Item>
                        <Form.Item label="Season" name="season">
                            {season.name}
                        </Form.Item>
                        <Form.Item label="Stage Name" name="name">
                            <Input placeholder="Name" />
                        </Form.Item>
                        <Form.Item label="Date" name="date">
                            <DatePicker placeholder="Stage Date" format="DD/MM/YYYY" />
                        </Form.Item>
                        <Form.Item label="Stage Number" name="stageNumber">
                            <InputNumber placeholder='Stage Number' />
                        </Form.Item>
                        <Form.Item label="Round" name="round" style={{ display: 'none' }}>
                            <InputNumber placeholder='Round' />
                        </Form.Item>
                        <Form.Item label="Swiss Rounds" name="turns">
                            <InputNumber min={0} max={10} placeholder='Swiss Rounds' />
                        </Form.Item>
                        <Form.Item label="Players Cap" name="playerCap">
                            <InputNumber min={0} max={1000} placeholder="Max participants" />
                        </Form.Item>
                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <Button type="primary" htmlType="submit">
                                Add Stage
                            </Button>
                            <Button type="primary" danger onClick={toggleCancel}>
                                Cancel
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </>
    )
}

{/* <Popover title="Aggiungi tappa" open={isActive} trigger="click" content={popoverContent} onOpenChange={handleOpenChange}>
                <Button style={{ marginTop: 16 }} type="primary" onClick={togglePopover}>
                    Aggiungi Tappa
                </Button>
            </Popover> */}
export default AddStageAdvanced;